import { createContext, useContext, useState, useCallback } from "react";
import DonateModal from "../components/DonateModal";

const DonateContext = createContext({ open: () => {}, close: () => {} });

export function DonateProvider({ children }) {
  const [isOpen, setIsOpen] = useState(false);
  const open = useCallback(() => setIsOpen(true), []);
  const close = useCallback(() => setIsOpen(false), []);

  return (
    <DonateContext.Provider value={{ open, close }}>
      {children}
      <DonateModal open={isOpen} onClose={close} />
    </DonateContext.Provider>
  );
}

export function useDonate() {
  return useContext(DonateContext);
}
